// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3jyme","title":"Images90_title__AjUgP","images":"Images90_images__cTrgV"};